import { subscribeOnAuthentification } from './subscribeOnAuthentification';
import { IRequestAuthenticationParameters } from './types';
import { TThunkAction } from '../../types/redux';

export function requestAuthentication(parameters?: IRequestAuthenticationParameters): TThunkAction {
  return (dispatch, _getState, context) => {
    /* istanbul ignore else */
    if (typeof window !== 'undefined') {
      const { microfrontendsAPI } = context;

      dispatch(subscribeOnAuthentification(parameters));

      if (microfrontendsAPI) {
        microfrontendsAPI.header.openAuthModal({
          autoRefresh: false,
          viewData: parameters?.viewData || null,
          source: parameters?.source || null,
        });
      }
    }
  };
}
